<template>
  <b-container fulid class="bv-example-row">
    <b-row >
      <p class="p1">最新询价</p></b-row>
    <!-- <b-table sticky-header :items="items" :fields="fields" :tbody-tr-class="rowClass"></b-table> -->
    <el-table
      :data="tableData"
      max-height="250"
      ref="table"
      :header-cell-style="{background:'#0d6efdd1',color:'#fff'}">
      <el-table-column
        prop="name"
        label="配件名称"
        width="320"
        align="center">
      </el-table-column>
      <el-table-column
        prop="spec"
        label="规格型号"
        width="180"
        align="center">
      </el-table-column>
      <el-table-column
        prop="unit"
        label="单位"
        align="center">
      </el-table-column>
      <el-table-column
        prop="num"
        label="数量"
        align="center">
      </el-table-column>
      <el-table-column
        prop="location"
        label="地区"
        align="center">
      </el-table-column>
      <el-table-column
        prop="create_date"
        label="询价日期"
        align="center">
      </el-table-column>
    </el-table>
  </b-container>
</template>
<script>
import request from"../../../utils/request"
export default {
  name:'inquire',
  props:['tableData'],
  data(){
    return{
    }
  },
  mounted(){
    this.$nextTick(()=>{
      this.infinitScroll()
    })
  },
  methods:{
    rowClass(item, type) {
        if (!item || type !== 'row') return
        if (item.status === 'awesome') return 'table-success'
      },
    infinitScroll() {
      // 拿到表格挂载后的真实DOM
      const table = this.$refs.table;
      // 拿到表格中承载数据的div元素
      const divData = table.bodyWrapper
      divData.onmouseover = function () {
        clearInterval(t);
      }; //鼠标移入，停止滚动
      divData.onmouseout = function () {
        start()
      }; //鼠标移出，继续滚动
 
      // 拿到元素后，对元素进行定时增加距离顶部距离，实现滚动效果(此配置为每100毫秒移动1像素)
      let t;
      function start() {
        // 数据少于表格高度停止滚动
        // if (divData.clientHeight >= divData.scrollHeight){
        //   return;
        // }
        t = setInterval(() => {
        // 元素自增距离顶部1像素
        divData.scrollTop += 2
        // 判断元素是否滚动到底部(可视高度+距离顶部=整个高度)
        if (divData.clientHeight + divData.scrollTop == divData.scrollHeight) {
          // 重置table距离顶部距离
          divData.scrollTop = 0
        }
      }, 100)
      }
      start()
    },
  }
}
</script>
<style scoped>
.p1{
  font-size: 22px;
    font-weight: 500;
    width: 100%;
    /* margin-bottom: 17px; */
    background-color: rgb(248, 249, 250);
    line-height: 58px;
    white-space: nowrap;
}
div /deep/.el-table__body-wrapper, .el-table__footer-wrapper, .el-table__header-wrapper {
    width: 98.6%;
}
div /deep/.el-table--scrollable-y .el-table__body-wrapper::-webkit-scrollbar{
  width: 3px;
}
div /deep/.el-table--scrollable-y .el-table__body-wrapper::-webkit-scrollbar-thumb {
    border-radius: 10px;
   -webkit-box-shadow: inset 0 0 5px rgba(13, 110, 253, 0.82);;
    background: rgba(13, 110, 253, 0.82);;
  }
div /deep/.el-table--scrollable-y .el-table__body-wrapper::-webkit-scrollbar-track {
    -webkit-box-shadow: inset 0 0 5px rgba(0,0,0,0.2);
    border-radius: 10px;
    background: #EDEDED;
  }
div /deep/.el-table tr {
    background-color: #ebeef587;
}
</style>